// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"463":"3fc6ad4f","477":"61e381f7"}[chunkId] + ".chunk.js";
};